import { useContext } from 'react';

import { ImportWizardContext } from './importWizardContext.js';

/**
 * The shared state of the "Add members from a file" wizard and its helpers.
 *
 * @returns {{
 *   state: import('./importWizardReducer.js').initialImportWizardState,
 *   dispatch: (action: { type: string, payload?: unknown }) => void,
 *   loadFile: (sheet: { file: object, rawRows: object[] }) => void,
 *   setStep: (step: string) => void,
 *   setMapping: (column: string, target: string) => void,
 *   reset: () => void,
 *   parsing: boolean,
 *   setParsing: (parsing: boolean) => void,
 * }}
 */
export function useImportWizard() {
  const context = useContext(ImportWizardContext);
  if (!context) throw new Error('useImportWizard must be used inside <ImportWizardProvider>');
  return context;
}
